import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AdminLoginService } from './services/login/adminlogin.service';
import { AuthSessionService, SessionDetails } from './services/auth-session/auth-session.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'rhema-app';
  adminLoggedIn: any;
  adminLoggedData: any;
  isLoggedIn: boolean = false;
  currentRoute: any;
  currentRole: any;
  isUserLoggedInCheck: boolean | any;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  currentYear: any;
  checkAdmin: any;
  sessionDetails: SessionDetails = { state: 'active', remaining: 0 };
  isExtendingSession = false;
  sessionError = '';

  constructor(
    private router: Router,
    private adminLoginService: AdminLoginService,
    private authSession: AuthSessionService
  ) {}

  ngOnInit() {

    this.authSession.sessionDetails$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((details) => (this.sessionDetails = details));
    this.authSession.startMonitoring();

    this.isUserLoggedInCheck = localStorage.getItem('isUserLoggedIn');
    this.currentYear = new Date().getFullYear();
    this.adminLoginService.listen().subscribe((result) => {
      this.adminLoggedIn = result.loggedIn;
      this.currentRole = result.role;
    });
    this.checkAdmin = localStorage.getItem('checkAdmin');
    this.adminLoggedIn = JSON.parse(this.checkAdmin);
    this.currentRole = localStorage.getItem('role');

    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationStart) {
    //     this.currentRoute = event.url;
    //     if (this.adminLoggedIn && this.currentRoute === '/' && this.currentRole !== 'Coordinator') {
    //       this.router.navigateByUrl('/');
    //     } else if (this.adminLoggedIn && this.currentRoute === '/' && this.currentRole === 'Coordinator') {
    //       this.router.navigateByUrl('/dashboard');
    //     } else if (this.adminLoggedIn === false && this.currentRoute === '/reset-password') {
    //       this.router.navigateByUrl('/');
    //     }
    //   }
    // });

  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.authSession.stopMonitoring();
  }

  get showSessionDialog(): boolean {
    const publicRoutes = ['/', '/login'];
    return !publicRoutes.includes(this.router.url.split('?')[0]) &&
      this.sessionDetails.state !== 'active';
  }

  get formattedSessionRemaining(): string {
    const seconds = Math.max(0, Math.ceil(this.sessionDetails.remaining / 1000));
    return `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(
      seconds % 60
    ).padStart(2, '0')}`;
  }

  extendSession(): void {
    if (this.sessionDetails.state === 'expired') {
      this.authSession.logoutAndRedirect();
      return;
    }
    if (!navigator.onLine) {
      this.sessionError = 'Connect to the internet to extend this session.';
      return;
    }

    this.isExtendingSession = true;
    this.sessionError = '';
    this.authSession.refreshAccessToken().subscribe({
      next: () => (this.isExtendingSession = false),
      error: (error) => {
        this.isExtendingSession = false;
        if (error?.status === 401 || error?.code === 'REFRESH_TOKEN_MISSING') {
          this.authSession.logoutAndRedirect();
          return;
        }
        this.sessionError = error?.error?.error || error?.error?.message ||
          'The session could not be extended. Please try again.';
      },
    });
  }

  logoutSession(): void {
    this.authSession.logoutAndRedirect();
  }

  logOut() {
    this.authSession.logoutAndRedirect();
  }

  redirectToHome() {
    this.router.navigateByUrl('/');
  }

  // onActivate(event: any) {
  //   window.scroll({
  //     top: 0,
  //     left: 0,
  //     behavior: 'smooth'
  //   });
  // }

  onActivate(e: any, scrollContainer: any) {
    scrollContainer.scrollTop = 0;
  }
}
